/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

import { Breakpoints } from '@angular/cdk/layout';

// Map flex-layout aliases to standard media queries
export const ALIAS_QUERY_MAP = new Map<string, string | string[]>([
  ['xs', Breakpoints.XSmall],
  ['sm', Breakpoints.Small],
  ['md', Breakpoints.Medium],
  ['lg', Breakpoints.Large],
  ['xl', Breakpoints.XLarge],
  [
    'gt-xs',
    [
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge,
    ],
  ],
  ['gt-sm', [Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge]],
  ['gt-md', [Breakpoints.Large, Breakpoints.XLarge]],
  ['gt-lg', [Breakpoints.XLarge]],
  ['lt-sm', Breakpoints.XSmall],
  ['lt-md', [Breakpoints.XSmall, Breakpoints.Small]],
  ['lt-lg', [Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium]],
  [
    'lt-xl',
    [
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
    ],
  ],
]);

export const BREAKPOINT_MAP = new Map([
  [Breakpoints.XSmall, 'xs'],
  [Breakpoints.Small, 'sm'],
  [Breakpoints.Medium, 'md'],
  [Breakpoints.Large, 'lg'],
  [Breakpoints.XLarge, 'xl'],
]);
